import {
    Column,
    Container,
    Image,
    Panel9Slice,
    Row,
    Text,
} from '@wonderlandengine/react-ui/components';
import {useEffect, useMemo, useState} from 'react';
import {
    RotBMaterialContextValue,
    useRotBMaterialContext,
} from '../utils/rotb-material-context.js';
import {parseColor} from '../utils/utils.js';
import {colorSwatch} from '../utils/colorSwatch.js';
import {Align, Justify, PositionType} from '@wonderlandengine/react-ui';
import {MissionCompleteNotificationModel as MissionCompleteNotificationModel} from '../../models/MissionCompleteNotificationModel.js';
import {UiTexturesManager} from '../components/ui-textures-manager.js';

export const MissionAchievementNotification = () => {
    const rotbMats = useRotBMaterialContext() as RotBMaterialContextValue;
    const material = rotbMats?.windowMaterial;

    const bm = useMemo(() => material!.clone(), []);

    (bm as any).setColor(parseColor(colorSwatch.MissionRequirementsBG));
    const [isVisible, setIsVisible] = useState(false);

    const [message, setMessage] = useState('');
    const [messageDetail, setMessageDetail] = useState('');

    useEffect(() => {
        const change = (prop) => {
            if (prop === 'isVisible') {
                setMessage(MissionCompleteNotificationModel.instance.message);
                setMessageDetail(MissionCompleteNotificationModel.instance.messageDetail);
                setIsVisible(MissionCompleteNotificationModel.instance.isVisible);
            }
        };
        MissionCompleteNotificationModel.instance.propertyChanged.add(change);

        return () => {
            MissionCompleteNotificationModel.instance.propertyChanged.remove(change);
        };
    }, []);

    return (
        <>
            {isVisible && (
                <Container
                    position={PositionType.Absolute}
                    z={0.02}
                    width="100%"
                    alignItems={Align.Center}
                >
                    <Panel9Slice
                        top={75}
                        width={580}
                        material={bm}
                        borderSize={16}
                        borderTextureSize={0.3}
                        height={100}
                        rounding={0}
                        z={0.02}
                    >
                        <Row
                            width="100%"
                            top={20}
                            height={80}
                            justifyContent={Justify.Center}
                        >
                            <Container
                                left={20}
                                width={80}
                                height={80}
                                justifyContent={Justify.Center}
                                alignItems={Align.Center}
                            >
                                <Image
                                    z={0.022}
                                    width={50}
                                    height={50}
                                    rounding={0}
                                    src={UiTexturesManager.instance.checklist}
                                ></Image>
                            </Container>
                            <Column justifyContent={Justify.Center} flexGrow={1} gap={20}>
                                <Text fontSize={22} textAlign="center" z={0.022}>
                                    {message}
                                </Text>
                                <Text fontSize={12} textAlign="center" z={0.022}>
                                    {messageDetail}
                                </Text>
                            </Column>
                        </Row>
                    </Panel9Slice>
                </Container>
            )}
        </>
    );
};
